"use client";

import React from "react";
import { House, Briefcase, Package, Trash2, ChevronRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Marketing / Advertising",
  description: "Meta Ads, TikTok Ads, Google Ads, Pinterest Ads, Email Marketing - Targeted promotions beside content.",
  icon: House
}, {
  title: "Software development",
  description: "Designing & developing, and deploying websites and scalable mobile applications.",
  icon: Briefcase
}, {
  title: "AI Integration",
  description: "Made to automate workflows, enhance user experience, analyze data and improve business efficiency.",
  icon: Package
}, {
  title: "Branding",
  description: "Creating distinctive brand identities that build trust, recognition, and long-term costumer loyalty.",
  icon: Trash2
}];
export default function OurExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222473" id="engineering-excellence" className="bg-background py-24 w-full overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`mb-16 md:mb-20 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default font-bold text-3xl md:text-5xl text-foreground tracking-tighter mb-4">
            Engineering Excellence
          </h2>
          <div className="w-20 h-1.5 bg-primary"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
          const Icon = service.icon;
          const delay = index * 150;
          return <div key={index} data-index={index} className={`transition-all duration-700 ease-out fill-mode-both ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${delay}ms`
          }}>
                <Card className="relative h-full overflow-hidden border-border bg-card shadow-md hover:border-primary transition-all duration-300 group/card rounded-md">
                  <CardContent className="p-8 flex flex-col h-full">
                    
                    {}
                    <div className="relative mb-8 h-16 flex items-center">
                      <span className="absolute -left-4 -top-6 text-8xl font-mono font-bold text-muted-foreground/10 select-none pointer-events-none transition-transform duration-500 group-hover/card:-translate-y-2 group-hover/card:text-primary/20">
                        0{index + 1}
                      </span>
                      <div className="relative z-10">
                        <Icon className="size-10 text-primary transition-transform duration-300 group-hover/card:scale-110" strokeWidth={1} />
                      </div>
                    </div>

                    {}
                    <div className="flex-grow">
                      <h3 className="font-default font-bold text-2xl mb-3 tracking-tight text-foreground">
                        {service.title}
                      </h3>
                      <p className="text-muted-foreground line-clamp-2 text-sm leading-relaxed mb-6 font-default">
                        {service.description}
                      </p>
                    </div>

                    {}
                    

                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}